import {Component, Input, OnInit} from "@angular/core";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";

/**
 * Hint that is optional closable
 */
@Component({
  selector: 'dialog-hint',
  templateUrl: './hint.component.html',
  styleUrls: []
})
export class HintComponent implements OnInit {

  /**
   * textkey for the hint text
   */
  @Input() textkey: string;

  /**
   * toggle if the hint is closable, default is true
   */
  @Input() closable: boolean = true;

  /**
   * if the id is set and the item is closed, it will save this to the sessionStorage and therefore not be seen again in this session
   */
  @Input() remeberCloseId: string = null;

  /**
   * toggle if we want to show the pdf and print icons, default is true
   */
  @Input() showPdfAndPrintIcons: boolean = true;

  /**
   * check if it is an internal portal, default is false
   */
  @Input() isInternalPortal: boolean = false;

  /**
   * make the hint clickable and jump to element with specific id
   */
  @Input() clickTarget: string = null;

  /**
   * some extra css classes
   */
  class: string = '';

  constructor(protected elementService: ElementService, protected portalService: PortalService) {
  }


  /**
   * @inheritDoc
   */
  ngOnInit() {
    // check if the item was closed already
    try {
      if (this.remeberCloseId && window.sessionStorage && window.sessionStorage.getItem(this.remeberCloseId) === "1") {
        this.class = 'hidden';
      }
    } catch (e) {

    }

    //check if it is an internal portal
    this.isInternalPortal = this.portalService.isInternalPortal();
  }

  /**
   * close the hint
   */
  closeHint(): void {
    this.class = 'closing';
    setTimeout(() => {
      this.class = 'hidden';
    }, 500);

    try {
      if (this.remeberCloseId && window.sessionStorage) {
        window.sessionStorage.setItem(this.remeberCloseId, "1");
      }
    } catch (e) {

    }
  }

  /**
   * jump to lead/download module after click on hint
   */
  onClickToLeadModule() {
    this.elementService.scrollToElement(document.querySelector('#' + this.clickTarget));
  }

}
